import styled from "styled-components";
import { Colors } from "../../config/Constants";

type PaginationButtonProps = {
  label?: string | number;
  isActive?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  children?: JSX.Element;
};

export const PaginationButton = ({
  label,
  isActive,
  onClick,
  disabled,
  children,
}: PaginationButtonProps) => {
  return isActive ? (
    <FilledStyledButton onClick={onClick}>
      {label || children}
    </FilledStyledButton>
  ) : (
    <StyledButton disabled={disabled} onClick={onClick}>
      {label || children}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  width: 27px;
  height: 27px;
  border: 1px solid ${Colors.solitude};
  border-radius: 3px;
  background-color: white;
  color: ${(props) => (props.disabled ? "#C4C4C4" : "#505470")};
  margin-right: 7px;
  font-weight: 400;
  font-family: "Poppins-Book";
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

const FilledStyledButton = styled.button`
  width: 27px;
  height: 27px;
  border: 1px solid ${Colors.solitude};
  border-radius: 3px;
  background-color: ${Colors.black};
  color: ${Colors.white};
  margin-right: 7px;
  font-weight: 400;
  font-family: "Poppins-Book";
  cursor: pointer;
`;
